import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss'],
    standalone: false
})
export class VersionComponent implements OnInit {
  appVersion = environment.appVersion;

  constructor() { }

  ngOnInit() {
  }

}
